import React from 'react';
import backButton from '../Assets/back.svg';

function Back({ onClick } ) {
    return (
        <div>
            <img
                src={backButton}
                alt="back"
                className="w-7 h-7 mt-2 cursor-pointer mb-2 ml-2 mr-2"
                title="Go back to previous page"
                onClick={onClick}
            />
        </div>
    );
}

export default Back;
